import React, { useRef, useState, useEffect } from "react";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode } from "primereact/api";
import "primeicons/primeicons.css";

import { TabView, TabPanel } from "primereact/tabview";
import instance from "../../api/api.js";

import { styleIcone } from "../../shared";
import { IoMdEye } from "react-icons/io";
import {
  MenuPoint,
} from "../../shared/compoments";
import { IoPersonOutline } from "react-icons/io5"
import AllCompomentShared from "../../shared/compoments/AllCompomentShared.jsx";


const options = [
  {
    name: "Voir plus",
    path: "/clients/",
    icone: <IoMdEye style={styleIcone} />,
    isIdData: true,
  },
];

function ListeClients() {
  const [clients, setClients] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const ITEMSFILTER = ["nom", "prenom", "phone", "email"];
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    prenom: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    nom: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    phone: { value: null, matchMode: FilterMatchMode.EQUALS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  useEffect(() => {
    const getListUsers = async () => {
      try {
        const response = await instance.get("clients");
        console.log("CLIENTS", response);
        setClients(
          response.data.data.filter((item) => item.role.libelle === "Client")
        );
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    };
    getListUsers();
  }, []);
  return (
    <AllCompomentShared
    libelleHeaderComp={"Liste des clients"}
    titleStatisticHeaderComp={"Nombre de clients"}
    nbreTotalStatistiqueComp={clients.length}
    SearchTableLibelleBtn={"Nouveau client"}
    SearchTableIsBtn={false}
    SearchTableIsSearch={true}
    placeholderInputSearch={"Recherche"}
    globalFilterValue={globalFilterValue}
    onGlobalFilterChange={onGlobalFilterChange}
    iconeStatistiqueHeader={<IoPersonOutline fontSize={"2em"}/>} //import { IoPersonOutline } from "react-icons/io5";
    isLoading={isLoading}
    >
       <ClientsDatatable
          items={clients}
          itemsForFilter={ITEMSFILTER}
          filters={filters}
        />
      </AllCompomentShared>
  );
}
export function ClientsDatatable({ items, itemsForFilter, filters }) {
  const dt = useRef(null);

  const detailsInfo = (rowData) => {
    return <MenuPoint optionMenu={options} idData={rowData.id} />;
  };
  return (
    <div>
      <TabView>
        <TabPanel>
          <DataTable
            ref={dt}
            value={items}
            
            tableStyle={{ minWidth: "50rem" }}
            paginator
            rows={10}
            filters={filters}
            globalFilterFields={itemsForFilter}
          >
            <Column
              field="nom"
              style={{ textAlign: "center" }}
              header="Nom"
            ></Column>
            <Column
              field="prenom"
              style={{ textAlign: "center" }}
              header="Prénoms"
            ></Column>

            <Column
              field="phone"
              style={{ textAlign: "center" }}
              header="Téléphone"
            ></Column>
            <Column
              field="email"
              style={{ textAlign: "center" }}
              header="Email"
            ></Column>
            <Column
              field="id"
              style={{ textAlign: "center" }}
              header="Actions"
              body={detailsInfo}
            ></Column>
          </DataTable>
        </TabPanel>
      </TabView>
    </div>
  );
}

export default ListeClients;
